import {createContext} from 'react';

const BannerContext = createContext(null);

export default BannerContext;
